export const ORDER_DEFAULT_PAGE = ""
export const ORDER_PAGES = {
  "": "Overview",
}

export const ORDERS_DEFAULT_PAGE = ""
export const ORDERS_PAGES = {
  "": "Orders",
  // calendar: "Calendar",
  activities: "Activities",
}

export const ORDERS_PAGES_ACTIVITYLESS = {
  "": "Orders",
  // calendar: "Calendar",
}

export const pages = (
  location: string,
  order: boolean,
  activityless?: boolean
): { section: string; name: string; pages: Record<string, string>; defaultPage: string } => {
  const page = location.split("/").pop()
  let sectionPages: Record<string, string> = activityless ? ORDERS_PAGES_ACTIVITYLESS : ORDERS_PAGES
  let defaultPage = ORDERS_DEFAULT_PAGE
  if (order) {
    sectionPages = ORDER_PAGES
    defaultPage = ORDER_DEFAULT_PAGE
  }

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }
  return { section, name, pages: sectionPages, defaultPage }
}
